module.exports = __webpack_public_path__ + "static/media/contactIconOne.64b05222.webp";